// @ts-nocheck
import {
    getShipTosDataView,
    getCurrentShipTosDataView,
    getShipToState,
    getCurrentShipToState,
} from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getShipToStateByCustomerSequence } from "@store/Framework/Store/Data/ShipTos/ShipTosSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useShipTosDataView = convertSelectorToHook(getShipTosDataView);
export const useCurrentShipTosDataView = convertSelectorToHook(getCurrentShipTosDataView);
export const useShipToState = convertSelectorToHook(getShipToState);
export const useCurrentShipToState = convertSelectorToHook(getCurrentShipToState);
export const useShipToStateByCustomerSequence = convertSelectorToHook(getShipToStateByCustomerSequence);
